function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _possibleConstructorReturn(t, e) { if (e && ("object" == _typeof(e) || "function" == typeof e)) return e; if (void 0 !== e) throw new TypeError("Derived constructors may only return object or undefined"); return _assertThisInitialized(t); }
function _assertThisInitialized(e) { if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); return e; }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
function _getPrototypeOf(t) { return _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function (t) { return t.__proto__ || Object.getPrototypeOf(t); }, _getPrototypeOf(t); }
function _inherits(t, e) { if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function"); t.prototype = Object.create(e && e.prototype, { constructor: { value: t, writable: !0, configurable: !0 } }), Object.defineProperty(t, "prototype", { writable: !1 }), e && _setPrototypeOf(t, e); }
function _setPrototypeOf(t, e) { return _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (t, e) { return t.__proto__ = e, t; }, _setPrototypeOf(t, e); }
function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t.return && (u = t.return(), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }
import { ExternalTrackingExeption } from 'internals/exceptionHandler';
import { getFileName, getPlatform, compose, filterPropertiesByPatterns } from 'internals/helpers';
import { serializeObjects, serializeArrayItems, serializeObjectsProperties, removeNullsPropertiesFromObjects } from 'internals/transformers';
import amplitude from 'domains/trackingModules/amplitude/lib';
import braze from './lib';
import GeneralEventTrackingDispatcher from '../GeneralEventTrackingDispatcher';
import { brazeSdkEndpoint, OMITTED_PROPERTY_PATTERNS } from '../../constants';
var brazeInstance;
var transformUserProperties = function transformUserProperties(value) {
  if (value instanceof Array) {
    return serializeArrayItems(value);
  }
  return serializeObjects(value);
};
var transformEventProperties = function transformEventProperties(value) {
  return compose(serializeObjectsProperties, removeNullsPropertiesFromObjects)(value);
};
var setCustomUserAttributeIntoBraze = function setCustomUserAttributeIntoBraze(brazeUser, payload) {
  Object.entries(payload).map(function (_ref) {
    var _ref2 = _slicedToArray(_ref, 2),
      key = _ref2[0],
      value = _ref2[1];
    var validValue = transformUserProperties(value);
    brazeUser.setCustomUserAttribute(key, validValue);
    return [key, value];
  });
  brazeUser.setCustomUserAttribute('versionName', process.env.BUILD);
};
var setUserAmplitudeDeviceId = function setUserAmplitudeDeviceId(user) {
  var amplitudeInstance = amplitude.getInstance();
  Object.assign(user, {
    amplitude_device_id: amplitudeInstance.options.deviceId
  });
};
var brazeUserMethods = function brazeUserMethods(brazeRef, brazeUserRef) {
  return {
    user_id: function user_id(userId) {
      return brazeRef.changeUser(userId);
    },
    user_email: function user_email(userEmail) {
      return brazeUserRef.setEmail(userEmail);
    },
    phone_number: function phone_number(phoneNumber) {
      return brazeUserRef.setPhoneNumber(phoneNumber);
    },
    first_name: function first_name(firstName) {
      return brazeUserRef.setFirstName(firstName);
    },
    last_name: function last_name(lastName) {
      return brazeUserRef.setLastName(lastName);
    },
    amplitude_device_id: function amplitude_device_id(amplitudeDeviceId) {
      return brazeUserRef.addAlias('amplitudeDeviceId', amplitudeDeviceId);
    },
    web_push_token: function web_push_token(webPushToken) {
      if (webPushToken) {
        brazeRef.registerAppboyPushMessages(webPushToken);
      } else {
        brazeRef.registerAppboyPushMessages();
      }
      braze.display.automaticallyShowNewInAppMessages();
    }
  };
};
var callBrazeUserMethods = function callBrazeUserMethods(user, brazeMethods) {
  Object.keys(user).forEach(function (key) {
    return brazeMethods[key] && brazeMethods[key](user[key]);
  });
};
var updateUser = function updateUser(user, brazeRef, brazeUserRef) {
  var brazeMethods = brazeUserMethods(brazeRef, brazeUserRef);
  callBrazeUserMethods(user, brazeMethods);
};
var BrazeEventDispatcher = /*#__PURE__*/function (_GeneralEventTracking) {
  /*
  * This class is an interface for connecting to Braze SDK.
  * It is responsible for encapsulating all Braze SDK calls, and exposing general event to the application.
  * Always use the factory getBrazeEventDispatcherInstance to instantiate this class.
  */
  function BrazeEventDispatcher(_ref3) {
    var _this;
    var userFetcher = _ref3.userFetcher;
    _classCallCheck(this, BrazeEventDispatcher);
    _this = _callSuper(this, BrazeEventDispatcher, [{
      userFetcher: userFetcher
    }]);
    if (process.env.BRAZE_API_KEY && !process.env.SERVER && braze.initialize) {
      try {
        setUserAmplitudeDeviceId(_this.user);
        _this.braze = braze;
        var initialized = braze.initialize(process.env.BRAZE_API_KEY, {
          allowCrawlerActivity: true,
          baseUrl: brazeSdkEndpoint,
          enableLogging: process.env.ENABLE_BRAZE_LOGGING,
          manageServiceWorkerExternally: true
        });
        if (!initialized) {
          throw new Error('Braze failed to initialize, but no errors were thrown');
        }
        _this.brazeUser = _this.braze.getUser();
        updateUser(_this.user, _this.braze, _this.brazeUser);
        _this.braze.display.automaticallyShowNewInAppMessages();
        _this.braze.openSession();
      } catch (e) {
        throw new ExternalTrackingExeption({
          message: "Error on constructor: ".concat(JSON.stringify(e.message)),
          fileName: getFileName(__filename),
          externalTrackingService: 'Braze'
        });
      }
    }
    return _this;
  }
  _inherits(BrazeEventDispatcher, _GeneralEventTracking);
  return _createClass(BrazeEventDispatcher, [{
    key: "setUserProperties",
    value: function setUserProperties(payload) {
      var fetchUser = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
      try {
        if (!payload) {
          this.setDefaultUserProperties();
          return;
        }
        if (fetchUser) {
          this.user = this.validUserFetcher();
        }
        var localPayload = Object.assign({}, filterPropertiesByPatterns(payload, OMITTED_PROPERTY_PATTERNS.braze));
        if (localPayload.user_email) {
          var userEmail = localPayload.user_email;
          delete localPayload.user_email;
          this.user.user_email = userEmail;
        }
        if (localPayload.webPushToken) {
          var webPushToken = localPayload.webPushToken;
          delete localPayload.webPushToken;
          this.user.web_push_token = webPushToken;
        }
        if (localPayload.askForWebPushToken) {
          delete localPayload.askForWebPushToken;
          this.user.web_push_token = false;
        }
        updateUser(this.user, this.braze, this.brazeUser);
        setCustomUserAttributeIntoBraze(this.brazeUser, localPayload);
      } catch (e) {
        throw new ExternalTrackingExeption({
          message: "Error on setUserProperties: ".concat(JSON.stringify(e.message)),
          fileName: getFileName(__filename),
          externalTrackingService: 'Braze',
          extra: {
            payload: payload
          }
        });
      }
    }
  }, {
    key: "setDefaultUserProperties",
    value: function setDefaultUserProperties() {
      var fetchUser = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
      try {
        if (fetchUser) {
          this.user = this.validUserFetcher();
        }
        updateUser(this.user, this.braze, this.brazeUser);
        var defaultPayload = {
          login_status: this.user.login_status,
          platform: getPlatform()
        };
        setCustomUserAttributeIntoBraze(this.brazeUser, defaultPayload);
      } catch (e) {
        throw new ExternalTrackingExeption({
          message: "Error on setDefaultUserProperties: ".concat(JSON.stringify(e.message)),
          fileName: getFileName(__filename),
          externalTrackingService: 'Braze'
        });
      }
    }
  }, {
    key: "logWithDefaultEventProps",
    value: function logWithDefaultEventProps(eventName, state, extraProperties) {
      try {
        var eventProps = {};
        var validExtraProps = transformEventProperties(extraProperties);
        Object.assign(eventProps, this.createMainEventProperties(state));
        Object.assign(eventProps, validExtraProps);
        var delivered = this.braze.logCustomEvent(eventName, eventProps);
        if (!delivered) throw new Error("Failed to update event ".concat(eventName, " with properties: ").concat(eventProps));
      } catch (e) {
        throw new ExternalTrackingExeption({
          message: "Error on logWithDefaultEventProps: ".concat(JSON.stringify(e.message)),
          fileName: getFileName(__filename),
          externalTrackingService: 'Braze'
        });
      }
    }
  }, {
    key: "logWithDefaultProps",
    value: function logWithDefaultProps(eventName, state, extraProperties) {
      var fetchUser = eventName.includes('login') || eventName.includes('logout');
      this.setDefaultUserProperties(fetchUser);
      this.logWithDefaultEventProps(eventName, state, extraProperties);
    }
  }, {
    key: "identify",
    value: function identify() {
      /* eslint-disable no-console */
      console.warn('identify not implemented');
    }
  }]);
}(GeneralEventTrackingDispatcher);
var getBrazeEventDispatcherInstance = function getBrazeEventDispatcherInstance(userFetcher) {
  /*
  * Factory responsible for generatign a singleton.
    Only one instance of EventDispatcherHandler must exist at a time.
    This factory expects a function userFetcher that returns an object containing:
    {
      Boolean login_status;
      Integer user_id;
    }
  */

  if (!process.env.BRAZE_API_KEY) {
    return undefined;
  }

  if (brazeInstance) {
    return brazeInstance;
  }
  brazeInstance = new BrazeEventDispatcher({
    userFetcher: userFetcher
  });
  return brazeInstance;
};
export { BrazeEventDispatcher, setCustomUserAttributeIntoBraze };
export default getBrazeEventDispatcherInstance;
